<template>
  <b-modal
    id="StripePaymentModal"
    ref="modal"
    centered
    class="full-screen-modal"
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >

    <template #modal-header="{ close }"></template>

    <div>
      <StripeElementPayment
        ref="stripePayment"
        :confirm-params="confirmParams"
        :elements-options="elementsOptions"
        :pk="stripePk"
        :test-mode="testMode === 'development'"
        redirect="if_required"
        @error="handleErrors"
        @loading="handleLoading"
        @element-ready="handleElementReady"
      />
    </div>

    <template #modal-footer="{ ok, cancel, hide }">
      <div class="d-flex w-100">
        <b-button
          v-if="stripeElementReady"
          :disabled="isLoading"
          class="w-100 mr-2 d-md-block"
          variant="secondary"
          @click="closeModal()"
        >
          <div class="d-flex justify-content-center">
            <span v-if="!isLoading" class="align-self-center mt-small-px">{{ $t('Cancel') }}</span>
            <b-spinner v-else class="button-spinner"></b-spinner>
          </div>
        </b-button>
        <b-button
          v-if="stripeElementReady"
          :disabled="isLoading"
          class="w-100 mr-2 d-md-block"
          variant="primary"
          @click="handleSubmit()"
        >
          <div class="d-flex justify-content-center">
            <span v-if="!isLoading" class="align-self-center mt-small-px">{{
                (isInstantPayment ? $t('stripe.pay') : $t('stripe.caution')) + ` ${total}€`
              }}</span>
            <b-spinner v-else class="button-spinner"></b-spinner>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import api from "../../services/api";
import {StripeElementPayment} from '@vue-stripe/vue-stripe';


export default {
  name: "StripePaymentModal",

  components: {
    StripeElementPayment,
  },

  emits: ['closedStripePaymentModal', 'validatePayment'],

  props: {
    total: {
      required: true,
    },
    clientSecret: {
      required: true,
      type: String,
    },
    isInstantPayment: {
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      isLoading: false,
      hasError: false,
      hasSubmitted: true,
      stripeElementReady: false,

      testMode: process.env.NODE_ENV,
      stripePk: process.env.STRIPE_API_KEY,
      elementsOptions: {
        clientSecret: "",
        appearance: {
          rules: {
            '.Label': {
              color: '#EAEAEA',
            }
          }
        },
      },
      confirmParams: {
        return_url: ''
      },
    };
  },

  async mounted() {
    this.confirmParams.return_url = process.env.SERVER_URL
  },

  watch: {
    "clientSecret": function () {
      this.elementsOptions.clientSecret = this.clientSecret
    }
  },


  methods: {
    closeModal() {
      this.stripeElementReady = false
      this.$emit('closedStripePaymentModal')
      this.$bvModal.hide("StripePaymentModal")
    },

    async handleSubmit() {
      this.isLoading = true
      this.hasError = false
      this.hasSubmitted = true
      this.$refs.stripePayment.submit()
    },

    async handleErrors(error) {
      this.hasError = true
      console.log(error)
    },

    async handleLoading(loading) {
      this.isLoading = loading
      if (!loading && !this.hasError && this.hasSubmitted) {
        this.$emit('validatePayment')
        this.$bvModal.hide('StripePaymentModal')
      }
    },

    handleElementReady() {
      this.stripeElementReady = true
    }
  },
};
</script>

<!-- not scoped car modal -->
<style>

.button-spinner.spinner-border {
  margin-left: calc(1.5rem + 28px - 0.5rem);
  margin-right: calc(1.5rem + 28px - 0.5rem);
}
</style>



// WEBPACK FOOTER //
// src/components/annonce/StripePaymentModal.vue